/*
  access actions are sent to Redux Sagas located in:
  packages\tracs\src\redux\access\saga.js
*/
const actions = {
  USERGROUP_SEARCH: 'USERGROUP_SEARCH',
  USERGROUP_SEARCH_SUCCESS: 'USERGROUP_SEARCH_SUCCESS',
  USERGROUP_ACTIONS_SEARCH: 'USERGROUP_ACTIONS_SEARCH',
  USERGROUP_ACTIONS_SEARCH_SUCCESS: 'USERGROUP_ACTIONS_SEARCH_SUCCESS',
  USERGROUP_USERS: 'USERGROUP_USERS',
  USERGROUP_USERS_SUCCESS: 'USERGROUP_USERS_SUCCESS',
  USERGROUP_CREATE: 'USERGROUP_CREATE',
  USERGROUP_CREATE_SUCCESS: 'USERGROUP_CREATE_SUCCESS',
  USERGROUP_UPDATE: 'USERGROUP_UPDATE',
  USERGROUP_UPDATE_SUCCESS: 'USERGROUP_UPDATE_SUCCESS',
  USERGROUP_DELETE: 'USERGROUP_DELETE',
  USERGROUP_DELETE_SUCCESS: 'USERGROUP_DELETE_SUCCESS',
  USERGROUP_ERROR: 'USERGROUP_ERROR',

  apiUserGroupFields: () => ({
    type: actions.USERGROUP_FIELDS,
  }),

  apiUserGroups: queryString => ({
    type: actions.USERGROUP_SEARCH,
    queryString,
  }),

  apiUserGroupUsers: queryString => ({
    type: actions.USERGROUP_USERS,
    queryString,
  }),

  apiUserGroupCreate: createdUserGroup => ({
    type: actions.USERGROUP_CREATE,
    createdUserGroup,
  }),

  apiUserGroupUpdate: updatedUserGroup => ({
    type: actions.USERGROUP_UPDATE,
    updatedUserGroup,
  }),

  apiUserGroupDelete: deletedUserGroup => ({
    type: actions.USERGROUP_DELETE,
    deletedUserGroup,
  }),
};
export default actions;
